module.exports = __webpack_public_path__ + "img/NAPOLI.143c9084.png";